import { useEffect, useState } from "react";
import StyledTable, { ColumnHeader } from "../../../components/table/styled-table";
import { BiometricTransaction } from "../../../service/model/biometric.model";
import { configs } from "../../../app/app-configs";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { fetchBiometricDeviceTransactionsPage, selectIsLoading } from "../biometric-transaction.slice";
import BiometricTransactionTableRow from "./biometric-transaction-table-row";

const headers: ColumnHeader[] = [
    { name: "PIN" },
    { name: "Punch Time" },
    { name: "Status"},
    { name: "Processing Error" },
    { name: "Processed At"}
    // { name: "Actions", className: "action-header" }
]

interface TableProps {
    readonly transactions: BiometricTransaction[]
    readonly deviceId: number
}

const BiometricTransactionTable: React.FC<TableProps> = ({ transactions, deviceId }) => {
    const dispatch = useAppDispatch();
    const isLoading = useAppSelector(selectIsLoading);
    const [page, setPage] = useState(1);

    const pageCount = useAppSelector(state => state.biometricTransactions.totalPages);

    useEffect(() => {
        dispatch(fetchBiometricDeviceTransactionsPage({
            pagination: { page: page - 1, size: configs.PAGE_SIZE },
            deviceId: deviceId,
        }))
    }, [dispatch, page, deviceId]);

    const handlePageChange = (selectedPage: number) => {
        setPage(selectedPage);
    }

    return (
        <StyledTable headers={headers}
            currentPage={page}
            totalPages={pageCount}
            loading={isLoading}
            emptyMessage="No transactions found"
            onPageChange={handlePageChange}>

            {transactions?.map(transaction =>
                <BiometricTransactionTableRow transaction={transaction} key={transaction.id} />
            )}
        </StyledTable>
    );
}

export default BiometricTransactionTable;